import GoesBreadcrubms from 'pages/goes/components/geos-breadcrumbs';
import React, { useEffect, useRef, useState } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import colors from 'shared-components/theme/colors';
import { gilroyMedium } from 'shared-components/theme/fonts';
import Media from 'shared-components/theme/medias';
import styled, { keyframes } from 'styled-components';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Helmet } from 'react-helmet-async';

gsap.registerPlugin(ScrollTrigger);

const GeoBanner = ({
    bannerTextUrl,
    tagline,
    bgOne,
    bgTwo,
    bgThree,
    captions,
}) => {
    const images = [bgOne, bgTwo, bgThree];
    const imageCaptions = captions || [
        'Karachi Metropolitan Area',
        'Sunset at Karachi, sea view.',
        'Breath taking natural vista',
    ];
    const [currentIndex, setCurrentIndex] = useState(0);
    const [nextIndex, setNextIndex] = useState(1);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const bannerRef = useRef();
    const intervalRef = useRef();

    // Function to start the auto-slide timer
    const startAutoSlide = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        intervalRef.current = setInterval(() => {
            setIsTransitioning(true);

            setTimeout(() => {
                setCurrentIndex((prev) => (prev + 1) % images.length);
                setNextIndex((prev) => (prev + 2) % images.length);
                setIsTransitioning(false);
            }, 300);
        }, 5000);
    };

    // Initialize auto-slide on mount
    useEffect(() => {
        startAutoSlide();

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [images.length]);

    // Initialize nextIndex on mount
    useEffect(() => {
        setNextIndex((currentIndex + 1) % images.length);
    }, [currentIndex, images.length]);

    const handleDotClick = (index) => {
        if (index !== currentIndex && !isTransitioning) {
            setIsTransitioning(true);
            setNextIndex(index);

            // Clear the current interval and restart it
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }

            setTimeout(() => {
                setCurrentIndex(index);
                setIsTransitioning(false);
                // Restart the auto-slide timer after manual selection
                startAutoSlide();
            }, 300);
        }
    };

    // useEffect(() => {
    //     const el = bannerRef.current;

    //     ScrollTrigger.create({
    //         trigger: el,
    //         start: 'top top',
    //         end: '+=100%',
    //         onEnter: () => {
    //             gsap.to(el, {
    //                 filter: 'brightness(0.4)',
    //                 duration: 0.3,
    //                 // scale: '.95',
    //                 ease: 'power1.out',
    //             });
    //         },
    //         onLeaveBack: () => {
    //             gsap.to(el, {
    //                 filter: 'brightness(1)',
    //                 duration: 0.3,
    //                 // scale: '1',
    //                 ease: 'power1.out',
    //             });
    //         },
    //     });
    // }, []);

    return (
        <>
            <Wrapper
                bgImg={images[currentIndex]}
                nextBgImg={images[nextIndex]}
                isTransitioning={isTransitioning}
                id="home"
                ref={bannerRef}>
                <GoesBreadcrubms />
                <Overlay />
                <BannerTxtWrapper>
                    <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                        <BannerText src={bannerTextUrl}></BannerText>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOnce={true}
                        delay={300}>
                        <TagLine>{tagline}</TagLine>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOnce={true}
                        delay={500}>
                        <ScrollWrapper>
                            <Arrows>
                                {Array.from({ length: 3 }).map((_, index) => (
                                    <svg
                                        key={index}
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512">
                                        <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                                    </svg>
                                ))}
                            </Arrows>
                            <p>Scroll to see more</p>
                        </ScrollWrapper>
                    </ScrollAnimation>
                </BannerTxtWrapper>
                <DotsSection className="dots_section">
                    <ContentColumn className="content_column">
                        <Dots className="dots">
                            {images.map((image, i) => (
                                <Dot
                                    key={i}
                                    active={i === currentIndex}
                                    onClick={() => handleDotClick(i)}
                                    className="dot"
                                />
                            ))}
                        </Dots>
                        <Caption className="caption">
                            {imageCaptions[currentIndex]}
                        </Caption>
                    </ContentColumn>
                    <ThumbnailColumn className="thumbnail_column">
                        <Thumbnail
                            src={images[currentIndex]}
                            alt={`Slide ${currentIndex + 1}`}
                            className="thumbnail"
                            width={91}
                            height={78}
                        />
                    </ThumbnailColumn>
                </DotsSection>
            </Wrapper>
        </>
    );
};

export default GeoBanner;

const Wrapper = styled.div`
    position: sticky;
    z-index: 1;
    top: 30px;
    // height: 85.5vh;
    height: calc(100vh - 82px);
    padding: 100px 60px;
    margin-top: -61px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    scroll-margin-top: 100px;
    ${Media('large')} {
        margin-top: -4.629vw;
    }

    ${Media('xlscreens')} {
        padding: 6vw 5vw;
        height: 90vh;
    }
    @media (max-width: 1440px) {
        padding: 10vw 5vw;
    }
    @media (max-width: 1000px) {
        top: 0;
    }
    ${Media('desktopscreens')} {
        padding: 5vw;
        height: 89vh;
    }
    ${Media('tabletlandscape')} {
        padding: 100px 5vw;
        height: auto;
    }
    ${Media('mobile')} {
        padding: 100px 5vw;
    }

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background-image: ${({ bgImg }) => `url(${bgImg})`};
        background-size: cover;
        background-position: center top;
        background-repeat: no-repeat;
        opacity: ${({ isTransitioning }) => (isTransitioning ? 0 : 1)};
        transition: opacity 0.6s ease-in-out;
        z-index: -2;
    }

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        background-image: ${({ nextBgImg }) => `url(${nextBgImg})`};
        background-size: cover;
        background-position: center top;
        background-repeat: no-repeat;
        opacity: ${({ isTransitioning }) => (isTransitioning ? 1 : 0)};
        transition: opacity 0.6s ease-in-out;
        z-index: -1;
    }
`;
const Overlay = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 20%;
    background: linear-gradient(transparent, ${colors.geoGreen[100]});
`;
const BannerTxtWrapper = styled.div`
    position: relative;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    // justify-content: space-between;
    gap: 50px;
    margin-top: 40px;
    height: 100%;

    @media (min-width: 1880px) {
        margin-top: 7vw;
        gap: 3vw;
    }

    // .text_fold {
    //     display: flex;
    //     align-items: center;
    //     flex-direction: column;
    //     gap: 50px;

    //     @media (min-width: 1880px) {
    //         margin-top: 7vw;
    //         gap: 3vw;
    //     }
    // }
`;

const BannerText = styled.img`
    width: 89vw;
`;

const TagLine = styled.h4`
    font-size: 32px;
    color: ${colors.geoWhite[100]};
    font-family: ${gilroyMedium};
    font-weight: 500;
    margin: 0;

    ${Media('large')} {
        font-size: 1.7vw;
    }
    ${Media('mobile')} {
        font-size: 22px;
    }
`;
const fade = keyframes`
 0%{
    transform : translateY(-10px)
}
100%{
     transform : translateY(0px)

 }
`;
const ScrollWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    animation: ${fade} 1.3s ease-in-out infinite alternate;
    p {
        font-size: 16px;
        font-weight: 500;
        transition: 0.3s ease;
        margin: 0;
        transition: 0.3s ease;
        animation: fadeInOut 1.3s ease-in-out infinite alternate;
        @keyframes fadeInOut {
            0% {
                opacity: 0.5;
            }
            100% {
                opacity: 1;
            }
        }
        color: ${colors.geoWhite[100]};
        ${Media('large')} {
            font-size: 0.952vw;
        }
        ${Media('mobile')} {
            font-size: 14px;
        }
    }
`;

const arrowPulse = keyframes`
    0%, 66.67%, 100% { 
        fill: #fff; 
    }
    33.33% { 
        fill: #00ff00; 
    }
`;

const Arrows = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    border: 2px dashed #01411c;
    border-radius: 10px;
    max-width: 44px;
    width: 100%;
    margin: auto;

    ${Media('mobile')} {
        max-width: 38px;
    }

    svg {
        width: 12px;
        fill: #fff;
        animation: ${arrowPulse} 1.5s infinite;

        &:nth-child(1) {
            animation-delay: 0s;
        }
        &:nth-child(2) {
            animation-delay: 0.5s;
        }
        &:nth-child(3) {
            animation-delay: 1s;
        }
    }
`;

const DotsSection = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    justify-content: center;
    background: #042914;
    padding: 10px 10px 10px 20px;
    border-radius: 0 10px 10px 0;
    max-width: fit-content;
    position: absolute;
    left: 0;
    bottom: 0;

    ${Media('mobile')} {
        display: none;
    }
`;

const ThumbnailColumn = styled.div`
    display: flex;
    align-items: center;
`;

const ContentColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
`;

const Dots = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

const Thumbnail = styled.img`
    // width: 50px;
    // height: 50px;
    border-radius: 10px;
    object-fit: cover;
    transition: all 0.3s ease;

    ${Media('mobile')} {
        width: 40px;
        height: 40px;
        border-radius: 8px;
    }
`;

const Caption = styled.span`
    color: ${colors.white[50]};
    font-size: 13px;
    font-weight: 500;
    font-family: ${gilroyMedium};
    text-align: center;
    line-height: 1.2;

    ${Media('mobile')} {
        font-size: 11px;
    }
`;

const Dot = styled.button`
    width : 12px;
    height : 12px;
    display : block;
    background-color: ${({ active }) =>
        active ? colors.geoGreen[50] : colors.geoGreen[100]};
    border-radius: 50%;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        transform: scale(1.3);
    }

   }
`;
